/* Copyright (c) Trimble Inc. All rights reserved. */

export { Logger as default, Logger, CustomLogger as LoggerClass } from './Logger';
export type { LoggerConfig, LogLevel } from './Logger';
